import { createContext } from 'react';
import {
    QUERY_KEYS_SECURITY,
    useChartsData
} from '../../../../Common/hooks/useChartsData';
import { useSecurityFiltersContext } from '../../../Common/Filters/hooks/useSecurityFiltersContext';

export const RankingsChartsDataContext = createContext();

const RankingsChartsDataProvider = ({ children }) => {
    const { filters } = useSecurityFiltersContext();
    const currentYear = new Date().getFullYear();
    const filterParams = {
            year: filters.year?.value || '',
            month: filters.month?.value ? String(Number(filters.month?.value)) : "",
            location: filters.unidade.value,
            city: filters.cidade?.value,
    }

    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_SECURITY.RANKINGS_POLICE_STATION,
            url: 'governanceroom/securitydashboard/criminalData/rankings/byPoliceStation'
        },
        filterParams
    );

    const rankByDepartment = useChartsData(
        {
            key: QUERY_KEYS_SECURITY.RANKINGS_DEPARTMENT,
            url: 'governanceroom/securitydashboard/criminalData/rankings/byDepartment'
        },
        filterParams
    );

    const rankBySectional = useChartsData(
        {
            key: QUERY_KEYS_SECURITY.RANKINGS_SECTIONAL,
            url: 'governanceroom/securitydashboard/criminalData/rankings/bySectional'
        },
        filterParams
    );

    const rankByCity = useChartsData(
        {
            key: QUERY_KEYS_SECURITY.RANKINGS_CITY,
            url: 'governanceroom/securitydashboard/criminalData/rankings/byCity'
        },
        filterParams
    );

    const rankByNeighbourhood = useChartsData(
        {
            key: QUERY_KEYS_SECURITY.RANKINGS_NEIGHBOURHOOD,
            url: 'governanceroom/securitydashboard/criminalData/rankings/byNeighborhood'
        },
        filterParams
    );

    const rankByBattalion = useChartsData(
        {
            key: QUERY_KEYS_SECURITY.RANKINGS_BATTALION,
            url: 'governanceroom/securitydashboard/criminalData/rankings/byBattalion'
        },
        filterParams
    );

    const rankByCommand = useChartsData(
        {
            key: QUERY_KEYS_SECURITY.RANKINGS_COMMAND,
            url: 'governanceroom/securitydashboard/criminalData/rankings/byCommand'
        },
        filterParams
    );

    const rankByCompany = useChartsData(
        {
            key: QUERY_KEYS_SECURITY.RANKINGS_COMPANY,
            url: 'governanceroom/securitydashboard/criminalData/rankings/byCompany'
        },
        filterParams
    );

    const chartData = {
        byPoliceStation: data || [],
        byDepartment: rankByDepartment.data || [],
        bySectional: rankBySectional.data || [],
        byCity: rankByCity.data || [],
        byNeighbourhood: rankByNeighbourhood.data || [],
        byBattalion: rankByBattalion.data || [],
        byCommand: rankByCommand.data || [],
        byCompany: rankByCompany.data || []
    }

    return (
        <RankingsChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </RankingsChartsDataContext.Provider>
    );
};

export default RankingsChartsDataProvider;
